import { Phone, Mail } from "lucide-react";

export const StickyContactBar = () => (
  <div
    data-testid="sticky-contact-bar"
    className="fixed bottom-0 inset-x-0 z-50 border-t border-amber-500/30 bg-slate-950/95 backdrop-blur-xl"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-center gap-3 sm:gap-6">
      <a
        href="tel:+18077700243"
        data-testid="sticky-call-button"
        className="inline-flex items-center gap-2 rounded-full bg-amber-500 px-5 py-2.5 text-sm font-bold text-slate-950 transition-colors duration-200 hover:bg-amber-400"
      >
        <Phone className="h-4 w-4" />
        <span className="hidden xs:inline">Call</span> +1 807-770-0243
      </a>
      <a
        href="mailto:admin@1stnation-security.com"
        data-testid="sticky-email-button"
        className="inline-flex items-center gap-2 rounded-full border border-amber-500/40 px-5 py-2.5 text-sm font-semibold text-amber-300 transition-colors duration-200 hover:bg-amber-500/10"
      >
        <Mail className="h-4 w-4" />
        <span className="hidden sm:inline">admin@1stnation-security.com</span>
        <span className="sm:hidden">Email Us</span>
      </a>
    </div>
  </div>
);
